import React, { useEffect, useState } from "react";
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import Loader from "../../../components/loader";
import PrimePaginator from "../../../components/prime-paginator";
import DeleteConfirmationDialog from "../../../components/delete-confirmation";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { ConfirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { checkActionAuthorization, downloadCsvFile, IsFormValid, } from "../../../service/shared.service";
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined, } from "../../../utils/null-check";
import { toastOptObj } from "../../../utils/constants";
import { Dialog } from "primereact/dialog";
import { APIResponseEntity } from "../../../interface/api-responce";
import { PaginateRespEntity } from "../../../interface";
import { AxiosResponse } from "axios";
import { APIToGetMasterTrack, APIToCreateMasterTrack, APIToUpdateMasterTrack, APIToDeleteMasterTrack, APIToExportMasterTrack, } from "../../../service/api-service";
import { RadioButton } from "primereact/radiobutton";
import { MasterTrackDetailsEntity, MasterTrackFilterRequest, } from "../../../interface/production-master";
import { Dropdown } from "primereact/dropdown";

const Status = [
    { name: "Active", code: true },
    { name: "Inactive", code: false },
];

function MasterTrack() {
    const [status] = useState(["Active", "Inactive"]);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [masterTrackDetails, setMasterTrackDetails] = useState<MasterTrackDetailsEntity[]>([]);
    const [totalPageCount, setTotalPageCount] = useState<number>(0);
    const [filterReq, setFilterReq] = useState<MasterTrackFilterRequest>({
        pageSize: 10,
        pageNumber: 0,
        sortColumn: "createdAt",
        sortOrder: "desc",
        searchText: "",
        status: "",
        APICallCount: 0,
    });
    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>("");
    const [isMasterTrackDialogVisible, setIsMasterTrackDialogVisible] = useState<boolean>(false);
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [selectedMasterTrackId, setSelectedMasterTrackId] = useState<string>("");
    const [masterTrackCode, setMasterTrackCode] = useState<string>("");
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [masterTrackIsActive, setMasterTrackIsActive] = useState<boolean>(true);
    const [formErrors, setFormErrors] = useState({
        code: "Please enter code",
    });
    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            await fetchMasterTracks();
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [filterReq]);

    const fetchMasterTracks = async (): Promise<void> => {
        setIsLoading(true);
        const reqObj = {
            pageNumber: filterReq.pageNumber,
            pageSize: filterReq.pageSize,
            sortOrder: filterReq.sortOrder,
            sortColumn: filterReq.sortColumn,
            searchText: filterReq.searchText,
            ...(!IsStringNullEmptyOrUndefined(filterReq.status) && {
                status: filterReq.status,
            }),
        };
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetMasterTrack(reqObj);
            setMasterTrackDetails([]);
            setTotalPageCount(0);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setMasterTrackDetails(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj, });
                }
            } else {
                toast.error(resp?.data?.message, { ...toastOptObj, });
            }
        } catch (error) {
            toast.error("Unable to get master track", { ...toastOptObj, });
        } finally {
            setIsLoading(false);
        }
    };

    const onPageChange = (event: PaginatorPageChangeEvent): void => {
        setFilterReq(prev => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const onTableSort = (event: DataTableSortEvent): void => {
        if (event && event.sortField && event.sortOrder) {
            setFilterReq(prev => ({
                ...prev,
                sortColumn: event.sortField as string,
                sortOrder: event.sortOrder === 1 ? "asce" : "desc",
                pageNumber: 0,
                APICallCount: prev.APICallCount + 1,
            }));
        }
    };

    const handleAdd = (): void => {
        setIsEditMode(false);
        setSelectedMasterTrackId("");
        setMasterTrackCode("");
        setMasterTrackIsActive(true);
        setSubmitted(false);
        setFormErrors({
            code: "Please enter code",
        });
        setIsMasterTrackDialogVisible(true);
    };

    const handleEdit = (rowData: MasterTrackDetailsEntity): void => {
        if (!rowData || IsStringNullEmptyOrUndefined(rowData.id)) {
            return;
        }
        setSelectedMasterTrackId(rowData.id);
        setMasterTrackCode(rowData.code || "");
        setMasterTrackIsActive(rowData.isActive ?? true);
        setIsEditMode(true);
        setSubmitted(false);
        setFormErrors({
            code: "",
        });
        setIsMasterTrackDialogVisible(true);
    };

    const closeMasterTrackDialog = (): void => {
        setIsMasterTrackDialogVisible(false);
        setIsEditMode(false);
        setSelectedMasterTrackId("");
        setMasterTrackCode("");
        setMasterTrackIsActive(true);
        setSubmitted(false);
        setFormErrors({
            code: "Please enter code",
        });
    };
    const deleteMasterTrack = async (
        value: boolean
    ): Promise<void> => {
        if (!value) {
            return;
        }
        if (IsStringNullEmptyOrUndefined(isDeleteRecordId)) {
            return;
        }
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToDeleteMasterTrack(isDeleteRecordId);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    toast.success(axiosResp.message, { ...toastOptObj, });
                    setIsDeleteRecordId("");
                    setFilterReq(prev => ({
                        ...prev,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }));
                }
            } else {
                toast.error(resp?.data?.message || "Unable to delete master track", { ...toastOptObj, });
            }
        } catch (error) {
            toast.error("Unable to delete master track", { ...toastOptObj, });
        } finally {
            setIsLoading(false);
        }
    };

    const actionIconTemplate = (
        rowData: MasterTrackDetailsEntity
    ) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">
                {
                    checkActionAuthorization("update", "Master Tracker") && (
                        <li
                            data-toggle="tooltip"
                            title="Edit"
                        >
                            <img
                                src="assets/images/edit-icon.svg"
                                alt="Edit"
                                onClick={() => { handleEdit(rowData); }}
                            />
                        </li>
                    )
                }
                {
                    checkActionAuthorization("delete", "Master Tracker") && (
                        <li
                            data-toggle="tooltip"
                            title="Delete"
                            onClick={() => { setIsDeleteRecordId(rowData.id); }}
                        >
                            <DeleteConfirmationDialog isAccepted={deleteMasterTrack} />
                        </li>
                    )
                }
            </ul>
        );
    };

    const resetFilters = (): void => {
        setSelectedStatus("");
        setFilterReq(prev => ({
            ...prev,
            pageSize: 10,
            pageNumber: 0,
            sortColumn: "createdAt",
            sortOrder: "desc",
            searchText: "",
            status: "",
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const statusBodyTemplate = (rowData: MasterTrackDetailsEntity) => {
        return (
            <span className={`badge badge-${rowData.isActive === true ? "success" : "danger"}`}>                {rowData.isActive ? "Active" : "Inactive"}            </span>
        );
    };

    const codeFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.searchText}
                placeholder="Search by code"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        searchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const statusRowFilterTemplate = (options: any) => {
        return (
            <Dropdown
                value={selectedStatus}
                options={status}
                onChange={(e) => { handleChangeStatus(e.value); }}
                placeholder="Select status"
                className="p-column-filter"
                style={{ width: "10rem" }}
            />
        );
    };

    const handleChangeStatus = (
        e: string
    ) => {
        setSelectedStatus(e);
        setFilterReq(prev => ({
            ...prev,
            status: e === "Active" ? "true" : e === "Inactive" ? "false" : "",
            pageNumber: 0,
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const handleChange = (fieldName: string, value: string): void => {
        switch (fieldName) {
            case "code":
                setMasterTrackCode(value);

                setFormErrors(prev => ({
                    ...prev,
                    code: IsStringNullEmptyOrUndefined(value)
                        ? "Please enter code"
                        : "",
                }));
                break;

            default:
                break;
        }
    };

    const handleSaveMasterTrack = async (): Promise<void> => {
        setSubmitted(true);
        const isValid = IsFormValid(formErrors);
        if (!isValid) {
            return;
        }
        setIsLoading(true);
        let resp: AxiosResponse<APIResponseEntity>;
        try {
            if (isEditMode) {
                resp = await APIToUpdateMasterTrack(selectedMasterTrackId, { code: masterTrackCode.trim(), isActive: masterTrackIsActive, });
            } else {
                resp = await APIToCreateMasterTrack({ code: masterTrackCode.trim() });
            }
            if (resp && resp.data && (resp.status === 200 || resp.status === 201)) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                    toast.success(axiosResp.message, { ...toastOptObj, });
                    closeMasterTrackDialog();
                    setFilterReq(prev => ({
                        ...prev,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }));
                }
            } else {
                toast.error(resp?.data?.message, { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const fetchMasterTrackCsvDetails = async (): Promise<void> => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToExportMasterTrack();
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const excelUrl = axiosResp.data.xlsxUrl;

                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName: string = excelUrl.split("/").pop();

                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName);
                        }
                    }
                }
                else {
                    toast.error(axiosResp?.message, { ...toastOptObj, });
                }
            } else {
                toast.error(resp?.data?.message, { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <ConfirmDialog />
            <div className="content-wrapper">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row align-items-center">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <h4 className="card-title mb-0">
                                                        Master Track
                                                    </h4>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                                        {
                                                            checkActionAuthorization("create", "Master Tracker") && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-md font-weight-medium"
                                                                    onClick={handleAdd}
                                                                >
                                                                    Add Master Track
                                                                </button>
                                                            )
                                                        }
                                                        {
                                                            checkActionAuthorization("upgrade", "Allow to Export Master Tracker") && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-md font-weight-medium m-0 me-2"
                                                                    onClick={() => fetchMasterTrackCsvDetails()}
                                                                >
                                                                    Export Master Track
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end mt-2">
                                                <span
                                                    className="resetFilters text-primary cursor-pointer"
                                                    onClick={resetFilters}
                                                >
                                                    Reset Filters
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col">
                                            <DataTable
                                                value={masterTrackDetails}
                                                filterDisplay="row"
                                                scrollable
                                                sortField={filterReq.sortColumn}
                                                sortOrder={filterReq.sortOrder === "asce" ? 1 : -1}
                                                onSort={onTableSort}
                                                emptyMessage={"No master track found"}
                                            >
                                                <Column
                                                    field="code"
                                                    header="CODE"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={codeFilterTemplate}
                                                    style={{ minWidth: "250px", }}
                                                />
                                                <Column
                                                    field="isActive"
                                                    header="STATUS"
                                                    body={statusBodyTemplate}
                                                    filter
                                                    filterField="isActive"
                                                    showFilterMenu={false}
                                                    filterElement={statusRowFilterTemplate}
                                                    style={{ minWidth: "300px", }}
                                                />

                                                <Column
                                                    field="createdAt"
                                                    header="Date Created"
                                                    sortable
                                                    body={(rowData: MasterTrackDetailsEntity) =>
                                                        rowData.createdAt
                                                            ? new Date(rowData.createdAt).toLocaleDateString("en-GB")
                                                            : "-"
                                                    }
                                                    style={{ minWidth: "200px" }}
                                                />

                                                {
                                                    (checkActionAuthorization("update", "Master Tracker") || checkActionAuthorization("delete", "Master Tracker")) && (
                                                        <Column
                                                            header="Action"
                                                            body={actionIconTemplate}
                                                            style={{ minWidth: "220px", }}
                                                        />
                                                    )
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                    {
                                        !IsNullOrEmptyArray(masterTrackDetails) && (
                                            <div className="mt-3">
                                                <PrimePaginator
                                                    onPageChange={onPageChange}
                                                    pageNumber={filterReq.pageNumber}
                                                    pageSize={filterReq.pageSize}
                                                    totalRecords={totalPageCount}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                header={isEditMode ? "Edit Master Track" : "Add Master Track"}
                className="production-master-dialog"
                contentStyle={{ paddingBottom: "10px", }}
                resizable={false}
                draggable={false}
                visible={isMasterTrackDialogVisible}
                style={{ width: "450px", }}
                modal
                onHide={closeMasterTrackDialog}
                footer={
                    <div className="d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeMasterTrackDialog}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveMasterTrack}
                        >
                            {isEditMode ? "Update" : "Save"}
                        </button>
                    </div>
                }
            >
                <div className="row mt-3">
                    <div className="form-group mb-3">
                        <label>
                            CODE{" "}
                            <sup className="mandatory">
                                *
                            </sup>
                        </label>

                        <InputText
                            id="masterTrackCode"
                            value={masterTrackCode}
                            maxLength={25}
                            className="form-control"
                            placeholder="Enter code"
                            onChange={(e) => handleChange("code", e.target.value)}
                        />
                        {submitted && (
                            <small className="text-danger font-weight-500">                                {formErrors.code}                            </small>
                        )}
                    </div>
                    {isEditMode && (
                        <div className="form-group">
                            <label>
                                STATUS
                            </label>
                            <div className="d-flex mb-2">
                                {Status.map((option: any) => (
                                    <div
                                        key={option.code}
                                        className="d-flex align-items-center mb-2"
                                    >
                                        <RadioButton
                                            inputId={String(option.code)}
                                            name="status"
                                            className="me-2"
                                            value={option.code}
                                            onChange={(e) => setMasterTrackIsActive(e.value)}
                                            checked={masterTrackIsActive === option.code}
                                        />
                                        <label className="me-5">
                                            {option.name}
                                        </label>
                                    </div>
                                )
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    );
}

export default MasterTrack;